import React, { useState } from 'react';
import { Card, Title, TextInput, Button, Switch } from '@tremor/react';

export function SecurityCompliancePage() {
  const [formData, setFormData] = useState({
    dataRetentionDays: 90,
    require2FA: true,
    ipAllowlist: '',
    passwordExpiration: 90,
    sessionTimeout: 30,
    auditLogRetention: 365
  });

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // TODO: Implement save functionality
    console.log('Saving security settings:', formData);
  };

  return (
    <div className="space-y-6">
      <Title>Security & Compliance</Title>

      <Card>
        <h2 className="text-xl font-semibold mb-4">Data Retention</h2>
        <div className="space-y-4">
          <div className="space-y-2">
            <label className="text-sm font-medium">Data Retention Period (days)</label>
            <TextInput
              type="number"
              value={formData.dataRetentionDays}
              onChange={e => handleInputChange('dataRetentionDays', e.target.value)}
              placeholder="90"
            />
            <p className="text-xs text-gray-500">How long to keep customer data</p>
          </div>

          <div className="space-y-2">
            <label className="text-sm font-medium">Audit Log Retention (days)</label>
            <TextInput
              type="number"
              value={formData.auditLogRetention}
              onChange={e => handleInputChange('auditLogRetention', e.target.value)}
              placeholder="365"
            />
            <p className="text-xs text-gray-500">How long to keep audit logs</p>
          </div>
        </div>
      </Card>

      <Card>
        <h2 className="text-xl font-semibold mb-4">Authentication & Access</h2>
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="font-medium">Require Two-Factor Authentication</p>
              <p className="text-sm text-gray-500">Enforce 2FA for all admin users</p>
            </div>
            <Switch
              checked={formData.require2FA}
              onChange={value => handleInputChange('require2FA', value)}
            />
          </div>

          <div className="space-y-2">
            <label className="text-sm font-medium">IP Allowlist</label>
            <TextInput
              value={formData.ipAllowlist}
              onChange={e => handleInputChange('ipAllowlist', e.target.value)}
              placeholder="Enter IP addresses (comma-separated)"
            />
            <p className="text-xs text-gray-500">Restrict access to specific IP addresses</p>
          </div>

          <div className="space-y-2">
            <label className="text-sm font-medium">Password Expiration (days)</label>
            <TextInput
              type="number"
              value={formData.passwordExpiration}
              onChange={e => handleInputChange('passwordExpiration', e.target.value)}
              placeholder="90"
            />
            <p className="text-xs text-gray-500">Force password change after specified days</p>
          </div>

          <div className="space-y-2">
            <label className="text-sm font-medium">Session Timeout (minutes)</label>
            <TextInput
              type="number"
              value={formData.sessionTimeout}
              onChange={e => handleInputChange('sessionTimeout', e.target.value)}
              placeholder="30"
            />
            <p className="text-xs text-gray-500">Automatically log out after inactivity</p>
          </div>
        </div>
      </Card>

      <Card>
        <h2 className="text-xl font-semibold mb-4">Compliance Tools</h2>
        <div className="space-y-4">
          <Button variant="secondary" className="w-full">Export Compliance Report</Button>
          <Button variant="secondary" className="w-full">View Audit Logs</Button>
          <Button variant="secondary" className="w-full">Download Data Privacy Agreement</Button>
        </div>
      </Card>

      <div className="flex justify-end space-x-4">
        <Button variant="secondary">Reset to Defaults</Button>
        <Button onClick={handleSubmit}>Save Changes</Button>
      </div>
    </div>
  );
}